export default __webpack_public_path__ + "static/media/plus-icon.afa14a14.svg";